import React from "react"

const src = `https://utteranc.es/client.js`
const branch = `master`
const repo = `vidhi-mody/the-girl-on-fire-comments`
const theme = `github-light`

const Utterance = () => {
  const commentBox = React.createRef()

  React.useEffect(() => {
    const utterances = document.createElement(`script`)
    const config = {
      src,
      repo,
      branch,
      theme,
      label: `comment`,
      async: true,
      "issue-term": `pathname`,
      crossorigin: `anonymous`,
    }

    Object.keys(config).forEach((configKey) => {
      utterances.setAttribute(configKey, config[configKey])
    })

    if (commentBox && commentBox.current) {
      commentBox.current.appendChild(utterances)
    }
  }, [])
  return (
    <>
      <h2>Comments</h2>
      <div className="utterances" ref={commentBox} />
    </>
  )
}

export default Utterance
